module.exports = __webpack_public_path__ + "img/dpd_logo.9a97bcc2.svg";